<template>
    <b-card>
        <file-info-table :file="file" />
        <div class="action">
            <a v-if="deleteFile && $can('delete-files')"
                class="action_icon card-link pointer"
                :title="uLang('app.delete')"
                @click="$emit('deleteFile', file)"
            ><i class="fa fa-lg fa-trash"></i>
            </a>
        </div>
    </b-card>
</template>
<script>
    import FileInfoTable from '~/components/files/basic-info-table'

    export default {
        name: 'FileCard',

        props: {
            file: {
                type: Object,
                default: null,
                required: true,
            },
            deleteFile: {
                type: Boolean,
                default: true,
                required: false,
            }
        },

        components: {
            FileInfoTable,
        },

        data() {
            return {}
        },
    }
</script>
<style lang="scss" scoped>
    .action_icon {
        color: #5A4587 !important;
    }
    .action_icon:hover {
        color: lighten(#5A4587, 25%) !important;
    }
</style>